import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { getLeaderboardData } from '../../api/userApi'; // Use your existing helper!
import { AuthContext } from '../../context/AuthContext';
import { RANK_IMAGES, RANK_ORDER } from '../../utils/rankConstants';
import '../../Style/Leaderboard.css';
import { getTopUniqueGoals } from '../../utils/goalUtils';
import { CATEGORY_COLORS } from '../../utils/leaderboardConstants';

const FriendsLeaderboard = () => {
  const { currentUser } = useContext(AuthContext);
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFriends = async () => {
      if (!currentUser?.id) return;
      try {
        setLoading(true);
        // We pass 'following' as the view type
        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const data = await getLeaderboardData('friends', currentUser.id, userTz);
        setFriends(data);
      } catch (err) {
        console.error('Leaderboard Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFriends();
  }, [currentUser?.id]);

  if (loading) return <div className="lb-empty-state">Loading users...</div>;

  return (
    <div className="staircase-container">
      {/* Logic: We map through EVERY rank in rankOrder. 
         This ensures the "staircase" UI always exists.
      */}
      {RANK_ORDER.map((rank) => {
        const playersInRank = friends
          .filter((p) => p.rank?.toUpperCase() === rank)
          .sort((a, b) => (b.totalXp || 0) - (a.totalXp || 0));

        return (
          <div key={rank} className={`rank-tier-block tier-${rank.toLowerCase()}`}>
            <div className="tier-header-sticky">
              <img src={RANK_IMAGES[rank]} alt={rank} className="tier-emblem-mini" />
              <span className="tier-name">{rank}</span>
              <span className="tier-count">
                {playersInRank.length} {playersInRank.length === 1 ? 'User' : 'Legends'}
              </span>
            </div>

            <div className="tier-content">
              {playersInRank.length > 0 ? (
                <div className="player-row-grid">
                  {playersInRank.map((player) => {
                    console.log('Leaderboard Player Object:', player);
                    const playerTopGoals = getTopUniqueGoals(player.goals || []);
                    return (
                      <Link to={`/profile/${player.id}`} key={player.id} className="lb-player-card">
                        <div className="lb-player-avatar">
                          {player.profilePicUrl ? (
                            <img src={player.profilePicUrl} alt="" className="avatar-img" />
                          ) : (
                            player.firstName?.[0] || '?'
                          )}
                        </div>

                        <div
                          className={`lb-player-info ${playerTopGoals.length === 0 ? 'centered-info' : ''}`}
                        >
                          <div className="lb-card-top">
                            <span className="lb-player-name">
                              {player.firstName} {player.lastName ? `${player.lastName[0]}.` : ''}
                            </span>
                            {/* If you want XP to stay aligned with the name */}
                            <span className="lb-player-xp">
                              {(player.totalXp || 0).toLocaleString()} <small>XP</small>
                            </span>
                          </div>

                          {playerTopGoals.length > 0 && (
                            <div className="player-badge-row">
                              {playerTopGoals.map((goal, idx) => (
                                <span
                                  key={idx}
                                  className="skill-tag"
                                  style={{
                                    '--tag-color':
                                      CATEGORY_COLORS[goal.category] || CATEGORY_COLORS.Default,
                                  }}
                                >
                                  {goal.category}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      </Link>
                    );
                  })}
                </div>
              ) : (
                /* This renders inside the specific rank block if empty */
                <div className="lb-empty-state">No users followed in this tier yet</div>
              )}
            </div>
          </div>
        );
      })}
      {/* Optional: Show a "global" empty state only if the ENTIRE list is empty */}
      {friends.length === 0 && (
        <div className="lb-empty-footer">
          <p>Tip: Follow users from the Global tab to see them here!</p>
        </div>
      )}
    </div>
  );
};

export default FriendsLeaderboard;
